import number from "./number";
export default function (array, f) {
  var s = 0,
      n = array.length,
      a,
      i = -1,
      j = n;

  if (f == null) {
    while (++i < n) {
      if (!isNaN(a = number(array[i]))) s += a;else --j;
    }
  } else {
    while (++i < n) {
      if (!isNaN(a = number(f(array[i], i, array)))) s += a;else --j;
    }
  }

  if (j) return s / j;
}